import { AuthTypes } from '../types/auth'
import { xContestState, XContestTypes } from '../types/xContest'

const INITIAL_STATE: xContestState = {
  all: [],
  activities: [],
  leaderboard: [],
  userContests: [],
  joinForm: {
    contest_id: '',
    saving_type: '',
    device: 'web',
    saving_frequency: '',
    start_date: '',
    maturity_date: '',
  },
}

export const xContestReducer = (
  state: xContestState = INITIAL_STATE,
  action: any
): xContestState => {
  switch (action.type) {
    case XContestTypes.GET_ALL_XCONTESTS_SUCCESS: {
      return {
        ...state,
        all: action.payload,
      }
    }

    case XContestTypes.GET_USER_XCONTESTS_SUCCESS: {
      return {
        ...state,
        userContests: action.payload,
      }
    }

    case XContestTypes.GET_USER_XCONTEST_ACTIVITIES_SUCCESS: {
      return {
        ...state,
        activities: action.payload,
      }
    }

    case XContestTypes.GET_USER_XCONTEST_LEADERBOARD_SUCCESS: {
      return {
        ...state,
        leaderboard: action.payload,
      }
    }
    case XContestTypes.CONTEST_FORM_DATA: {
      return {
        ...state,
        joinForm: {
          ...state.joinForm,
          ...action.payload,
        },
      }
    }

    case XContestTypes.CLEAR_CONTEST_DATA: {
      return {
        ...state,
        joinForm: { ...INITIAL_STATE.joinForm },
      }
    }

    // case AuthTypes.: {
    //   return INITIAL_STATE
    // }

    default:
      return state
  }
}

export default xContestReducer
